import { useEffect, useRef, useState } from "react";
import { waLink } from "@/siteConfig";

export const Chip = ({ active, onClick, children, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={`font-mono-label text-[11px] tracking-[0.15em] uppercase border px-4 py-2.5 transition-colors duration-300 ${
      active
        ? "border-[#B8894B] text-[#B8894B] bg-[#1A2A24]"
        : "border-[#1A2A24] text-[#EDE7DA]/60 hover:border-[#B8894B]/60 hover:text-[#EDE7DA]"
    }`}
  >
    {children}
  </button>
);

export const LineInput = ({ label, testId, ...props }) => (
  <label className="block">
    <span className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[#EDE7DA]/45">
      {label}
    </span>
    <input
      data-testid={testId}
      {...props}
      className="mt-2 w-full bg-transparent border-b border-[#1A2A24] focus:border-[#B8894B] outline-none py-2.5 text-[#EDE7DA] placeholder-[#EDE7DA]/25 transition-colors duration-300"
    />
  </label>
);

export const DualCTA = ({ waMessage, onBook, prefix, bookLabel = "Book a call", waLabel = "Send on WhatsApp" }) => (
  <div className="flex flex-col sm:flex-row gap-3">
    <button
      type="button"
      data-testid={`${prefix}-book-call-cta`}
      onClick={onBook}
      className="font-mono-label text-xs tracking-[0.2em] uppercase bg-[#B8894B] text-[#0E1613] px-7 py-3.5 hover:bg-[#EDE7DA] transition-colors duration-300"
    >
      {bookLabel}
    </button>
    <a
      data-testid={`${prefix}-whatsapp-cta`}
      href={waLink(waMessage)}
      target="_blank"
      rel="noopener noreferrer"
      className="font-mono-label text-xs tracking-[0.2em] uppercase border border-[#5E8570] text-[#EDE7DA] px-7 py-3.5 hover:border-[#B8894B] hover:text-[#B8894B] transition-colors duration-300 text-center"
    >
      {waLabel}
    </a>
  </div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono-label text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#B8894B]">
    {children}
  </p>
);

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};
